export const NODE_ENV = process.env.NODE_ENV || ''



// WEBPACK FOOTER //
// ./app/env.js